import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import Dropdown from './Dropdown'
import { Box, Tooltip } from '@mui/material'
import { FileDownload } from '@mui/icons-material'
import { actionIconStyle } from 'components/ActionUtil'

const ExportList = ({
    exportList = [],
}) => {
    const dispatch = useDispatch()
    if (exportList.length > 1) {
        return <Dropdown icon={'file_download'} tooltip={i18n.export} listItem={exportList}/>
    }
    return (
        <Tooltip id={'export_list_action_navbar'} title={i18n.export}>
            <Box px={2}>
                <FileDownload
                    onClick={exportList.length ? exportList[0].onClick : () => dispatch(ToastrAction.toastrError(i18n.noData))}
                    sx={{ ...actionIconStyle }}
                />
            </Box>
        </Tooltip>
    )
}

ExportList.propTypes = {
    exportList: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.string,
    })).isRequired,
    toastrError: PropTypes.func,
}

export default ExportList
